import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { catColor } from "@/lib/lore";

export const EntityMultiSelect = ({ entities, value, onChange, testid = "entity-multi" }) => {
  const [q, setQ] = useState("");
  const shown = entities.filter((e) => e.name.toLowerCase().includes(q.toLowerCase()));
  const toggle = (id) => onChange(value.includes(id) ? value.filter((v) => v !== id) : [...value, id]);
  return (
    <div className="rounded-md border border-[#2D3442] bg-[#0F131A]" data-testid={testid}>
      <Input className="border-0 border-b rounded-none h-9" placeholder={`Filter ${entities.length} entries…`} value={q} onChange={(e) => setQ(e.target.value)} data-testid={`${testid}-filter`} />
      <div className="max-h-40 overflow-y-auto lf-scroll p-1">
        {shown.length === 0 && <div className="p-3 text-xs text-[#A8A090]">No entries.</div>}
        {shown.map((e) => (
          <label key={e.id} className="flex items-center gap-2 rounded px-2 py-1.5 text-sm cursor-pointer hover:bg-[#1A202C]">
            <Checkbox checked={value.includes(e.id)} onCheckedChange={() => toggle(e.id)} data-testid={`${testid}-option-${e.id}`} />
            <span className="h-1.5 w-1.5 rounded-full" style={{ background: catColor(e.category) }} />
            <span className="text-[#E8DFD1]">{e.name}</span>
          </label>
        ))}
      </div>
    </div>
  );
};
